<template>
  <div class="map-page">

    <div id="map"></div>
  </div>
</template>

<script>
/**
 * Mounted wird ausgeführt, wenn dom eingefügt wird
 */
export default {
  name: 'home',
  mounted() {
    const element = document.getElementById('map');
    const options = {
      zoom: 14,
      center: new google.maps.LatLng(47.071467, 8.277621),
    };
    this.map = new google.maps.Map(element, options);

    const marker = new google.maps.Marker({
      position: { lat: 47.070978, lng: 8.282165 },
      icon: 'http://icons.iconarchive.com/icons/iconsmind/outline/64/Bicycle-icon.png',
      map: this.map,
    });
  },
};
</script>

<style lang="scss">
  #map {
    height: 100vh;
    width: 100vw;
  }
</style>
